/* eslint-disable @typescript-eslint/no-explicit-any */
import { clsx } from 'clsx';
import * as styles from '../styles.css';

export const customizedGroupTick = (props: any) => {
  const { index, x, y, payload } = props;

  return (
    <g>
      <g>
        {index !== 0 && (
          <circle
            fill="#707a95"
            width={10}
            cx={x}
            cy={y - 2}
            r={4}
            height={10}
            stroke="none"
            className={clsx(styles['pin'], styles['custom-pin'])}
          />
        )}
        <text
          orientation="bottom"
          width="490"
          height="30"
          stroke="none"
          x={x}
          y={y + 5}
          textAnchor="middle"
          fill="#666"
        >
          <tspan x={x} dy="0.71em">
            {payload.value}
          </tspan>
        </text>
      </g>
    </g>
  );
};
